class ShippingCountdown {
  constructor(element, shippingTime) {
    this.element = element;
    this.output = element.querySelector('.js-output');
    this.shippingTime = shippingTime;

    this.init = this.init.bind(this);
    this.update = this.update.bind(this);
    this.show = this.show.bind(this);
    this.hide = this.hide.bind(this);
    this.check = this.check.bind(this);

    this.init();
  }

  init() {
    const now = new Date();
    const show = this.check(now);

    if (show) {
      this.update(now);
      this.show();
      this.updateInterval = setInterval(this.update, 1000);
    }
  }

  check(now) {
    const weekDay = now.getDay();
    const hours = now.getHours();
    const seconds = now.getSeconds();

    let show = true;
    if (hours > this.shippingTime || (hours === this.shippingTime && seconds > 0)) {
      show = false;
    }
    // Do not show on weekends
    if (weekDay === 0 || weekDay === 6) {
      show = false;
    }
    return show;
  }

  update() {
    const now = new Date();
    const show = this.check(now);

    if (show) {
      const then = new Date(`${now.toString().split(' ').slice(0, 4).join(' ')} ${this.shippingTime}:00:00`);
      const difference = then - now;
      const hours = Math.floor((difference / (1000 * 60 * 60)) % 24);
      const minutes = Math.floor((difference / (1000 * 60)) % 60);
      const seconds = Math.floor((difference / 1000) % 60);
      this.output.textContent = window.theme.strings.shippingCountdown
        .replace('%hours%', hours)
        .replace('%minutes%', minutes)
        .replace('%seconds%', seconds);
    } else {
      clearInterval(this.updateInterval);
      this.hide();
    }
  }

  show() {
    this.element.classList.remove('hidden');
  }

  hide() {
    this.element.classList.add('hidden');
  }
}

export default ShippingCountdown;
